

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { ListinoNazionale } from "src/app/models/listinoNazionale.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";


@Component({
  templateUrl: "./dialog-modifica-listino-nazionale.component.html",
  styleUrls: ["../listino.component.css"],
})
export class ModificaListinoNazionaleComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  public modificaListinoForm: FormGroup;
  protected listinoDaModificare:ListinoNazionale;
  
  protected isUpdatingListino:Boolean = false;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private impreseService: ImpreseService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _formBuilder: FormBuilder,
    private listiniService:ListiniService,
  ) {
    this.listinoDaModificare = this.config.data.listino;
    this.modificaListinoForm = this._formBuilder.group({
     // azienda:                    [null, [Validators.required]],
      scl1:                       [this.listinoDaModificare.scl1, [Validators.required]],
      scl2:                       [this.listinoDaModificare.scl2, [Validators.required]],
      scl3:                       [this.listinoDaModificare.scl3, [Validators.required]],
      scl4:                       [this.listinoDaModificare.scl4, [Validators.required]],
      scl5:                       [this.listinoDaModificare.scl5, [Validators.required]],
      preventivoBase:       [this.listinoDaModificare.preventivoBase, [Validators.required]], 
      
    });
  }

  ngOnInit(): void {
    
    this.modificaListinoForm.get('scl2')?.valueChanges.subscribe(() => this.updatePreventivoBaseItalia());
    this.modificaListinoForm.get('scl3')?.valueChanges.subscribe(() => this.updatePreventivoBaseItalia());
    this.modificaListinoForm.get('scl5')?.valueChanges.subscribe(() => this.updatePreventivoBaseItalia());

  }

 
  
  updatePreventivoBaseItalia() {
    const ita2 = this.modificaListinoForm.get('scl2')?.value || 0;
    const ita3 = this.modificaListinoForm.get('scl3')?.value || 0;
    const ita5 = this.modificaListinoForm.get('scl5')?.value || 0;
    this.modificaListinoForm.get('preventivoBase')?.setValue(ita2 + ita3 + ita5, { emitEvent: false });
  }
  
  
  isFormValorizzato(formGroup: FormGroup): boolean {
    return Object.values(formGroup.value).some(value => value !== null && value !== undefined && value !== '');
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isUpdatingListino = true;

      this.listinoDaModificare.scl1               = parseFloat(this.modificaListinoForm.value.scl1);
      this.listinoDaModificare.scl2               = parseFloat(this.modificaListinoForm.value.scl2);
      this.listinoDaModificare.scl3               = parseFloat(this.modificaListinoForm.value.scl3);
      this.listinoDaModificare.scl4               = parseFloat(this.modificaListinoForm.value.scl4);
      this.listinoDaModificare.scl5               = parseFloat(this.modificaListinoForm.value.scl5);
      this.listinoDaModificare.preventivoBase     = parseFloat(this.modificaListinoForm.value.preventivoBase);
 
        

       this.listiniService.modificaNazionale(this.listinoDaModificare).subscribe( {
        next: (resCreaProgetto) => {
          this.isUpdatingListino = false;
          this.dialogRef.close({ success: true });
        },
        error: (e) => {
            this.isUpdatingListino = false;
            this.logger.error(e);
            this.dialogRef.close({ success: false });
            this.messageService.add({
              severity: "error",
              summary: "ATTENZIONE",
              detail: "Errore in fase di modifica del listino!", life:10000
            });
      },
        complete: () => {

          //this.isLoadingResults = false;
        }
    }); 
    }
  }
}
